import { toast } from 'react-toastify'
import * as types from "./types";
import { createAxiosInstance } from "../utils/helpers";
import { showHideModalDelete, displayMessages } from '../actions/common';
import { API_URL } from "./index";

export function getDelegados(page = 1) {
    const axiosWithToken = createAxiosInstance()
    return (dispatch, getState) => {
        const showRecords = getState().delegados.get('showRecords')
        const orderBy = getState().delegados.get('orderBy')

        axiosWithToken.get(`${API_URL}/delegados`, {
            params: { page, showRecords, orderBy }
        }).then(res => {
            dispatch({
                type: types.OBTENER_DELEGADOS,
                payload: {
                    data: res.data.data,
                    page: res.data.current_page,
                    totalRecords: res.data.total
                }
            })
        }).catch(err => displayMessages(dispatch, err))
    }
}
export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        dispatch({ type: types.CAMBIAR_MOSTRAR_REGISTROS_DELEGADOS, payload: showRecords })
        dispatch(getDelegados(1))
    }
}
export function setOrderBy(field) {
    console.log(field)
    return (dispatch, getState) => {
        let current = getState().delegados.get('orderBy')
        current = current.set('field', field.Value)
        if (field === null) {
            current = current.set('asc', false)
        } else {
            current = current.set('asc', !current.get('asc'))
        }
        dispatch({ type: types.ORDENAR_DELEGADOS, payload: { orderBy: current } })
        dispatch(getDelegados(1))
    }
}
export function AddDelegado() {
    const axiosWithToken = createAxiosInstance()
    return (dispatch, getState) => {
        const data = getState().delegados.getIn(['modalAddDelegado', 'data'])

        if (!data.get('delegado') || !data.get('cenco') || !data.get('delegado') || data.get('tipo_solicitud').count() === 0) {
            return toast.warning("Todos los campos son obligatorios", { bodyClassName: 'toastify-content toastify-warning' })
        }
        if (data.getIn(["delegado", "id"]) === data.getIn(["responsable_cenco", "id"])) {
            return toast.warning("No puede delegarse a sí mismo", { bodyClassName: 'toastify-content toastify-warning' })
        }

        const action = getState().delegados.getIn(['modalAddDelegado', 'action'])

        if (action === 'create') {
            axiosWithToken.post(`${API_URL}/delegados`, data).then(res => {
                dispatch(getDelegados())
            }).catch(err => {
                displayMessages(dispatch, err)
            })
        } else {
            axiosWithToken.put(`${API_URL}/delegados/${data.get('id')}`, data).then(res => {
                dispatch(getDelegados())
            }).catch(err => {
                displayMessages(dispatch, err)
            })
        }
        dispatch({
            type: types.RESET_MODAL_ADD_DELEGADO
        })
    }
}
export function toggleSelectItem(item, checked) {
    return {
        type: types.CONMUTAR_SELECCION_DELEGADOS,
        payload: {
            index: item,
            checked
        }
    }
}

export function toggleSelectAllItems(checked) {
    return {
        type: types.CONMUTAR_SELECCION_TODOS_DELEGADOS,
        payload: {
            checked
        }
    }
}
export function showHideModalAddDelegados(show, title, action, id) {
    return dispatch => {

        if (show === false || action === "create") {
            dispatch({
                type: types.RESET_MODAL_ADD_DELEGADO,
            })
        }

        dispatch({
            type: types.MOSTRAR_MODAL_ADICIONAR_DELEGADOS,
            payload: { show, title, action, id }
        })
    }
}
export function deleteDelegados() {
    const axiosWithToken = createAxiosInstance()
    return (dispatch, getState) => {
        const selecteds = getState().delegados.get('delegados').filter(x => x.get('checked')).toJS()
        console.log(selecteds)
        axiosWithToken.delete(`${API_URL}/delegados`, { data: selecteds }).then(res => {
            dispatch(getDelegados())
        }).catch(err => {
            displayMessages(dispatch, err)
        }).finally(() => dispatch(showHideModalDelete()))
    }
}

export function updateInputs(path, value, immutable) {
    return {
        type: types.MODIFICAR_INPUTS_DELEGADOS,
        payload: { path, value, immutable }
    }
}

export function SelectTipoSolicitud(tipo_solicitud, check) {
    return {
        type: types.SELECCIONAR_TIPO_SOLICITUD,
        payload: { tipo_solicitud, check }
    }
}


// WEBPACK FOOTER //
// ./src/actions/delegados.js